import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useUser } from '../context/UserContext';

export const SingRouter: React.FC = () => {
  const { user } = useUser();
  const [destination, setDestination] = useState<string | null>(null);

  useEffect(() => {
    if (!user) return;

    const check = async () => {
      const { count } = await supabase
        .from('recordings')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id);

      setDestination((count ?? 0) > 0 ? '/song-library' : '/audition-songs');
    };

    check();
  }, [user]);

  if (!destination) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 size={32} className="animate-spin text-white/50" />
      </div>
    );
  }

  return <Navigate to={destination} replace />;
};
